import { Slot } from "@radix-ui/react-slot";
import {
  forwardRef,
  type ButtonHTMLAttributes,
  type ReactNode,
} from "react";
import { cn } from "../cn";

export type VarianteRkButton = "primary" | "brand" | "secondary" | "ghost" | "link";
export type TamanhoRkButton = "sm" | "md" | "lg";

export type PropsRkButton = ButtonHTMLAttributes<HTMLButtonElement> & {
  readonly variante?: VarianteRkButton;
  readonly tamanho?: TamanhoRkButton;
  readonly carregando?: boolean;
  readonly asChild?: boolean;
  readonly children: ReactNode;
};

/**
 * Botao Renke.
 * Variante `brand` (amarela): no maximo **1 por viewport**.
 * Primario: amarelo no dark, preto no light (tokens `--rk-action-primary-*`).
 */
export const Button = forwardRef<HTMLButtonElement, PropsRkButton>(
  function Button(
    {
      variante = "primary",
      tamanho = "md",
      carregando = false,
      asChild = false,
      className,
      disabled,
      children,
      type = "button",
      ...resto
    },
    ref,
  ) {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        {...resto}
        ref={ref}
        type={asChild ? undefined : type}
        disabled={disabled || carregando}
        aria-busy={carregando || undefined}
        className={cn(
          "rk-btn",
          "rk-focusable",
          `rk-btn--${variante}`,
          `rk-btn--${tamanho}`,
          carregando && "rk-btn--loading",
          className,
        )}
      >
        {carregando ? (
          <span className="rk-btn__spinner" aria-hidden>
            <span className="rk-btn__spinner-dot" />
          </span>
        ) : null}
        <span className="rk-btn__label">{children}</span>
      </Comp>
    );
  },
);
